import { z } from 'zod';
import { passwordSchema } from '@/schemas/shared';


export const ssoLinkAccountSchema = z.object({
  userName: z.string().min(1, 'El nombre de usuario es requerido'),
  rut: z.string(),
  email: z.string(),
  password: passwordSchema,
  confirmPassword: z.string().min(1, 'Debes confirmar la contraseña'),
}).refine((data) => data.password === data.confirmPassword, {
  message: 'Las contraseñas no coinciden',
  path: ['confirmPassword'],
});

export type SSOLinkAccountData = z.infer<typeof ssoLinkAccountSchema>;
